
import { motion } from "framer-motion";
import { Service } from "../types/model";
import { Button } from "./ui/button";
import { Clock, Calendar, Check } from "lucide-react";

interface ServiceCardProps {
  service: Service;
  selected?: boolean;
  onClick?: () => void;
  showBookButton?: boolean;
  onBookClick?: () => void;
}

const ServiceCard = ({
  service,
  selected = false,
  onClick,
  showBookButton = false,
  onBookClick,
}: ServiceCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`rounded-xl border p-5 h-full cursor-pointer transition-all duration-300 ${
        selected
          ? "border-chrona-accent bg-chrona-accent/10 shadow-lg shadow-chrona-accent/10"
          : "border-white/10 bg-black/40 backdrop-blur-xl hover:bg-black/60"
      }`}
      onClick={onClick}
    >
      <div className="flex flex-col h-full">
        <div className="flex-grow">
          <div className="flex items-start justify-between">
            <h3 className={`font-medium text-lg ${selected ? "text-chrona-accent" : "text-chrona-text"}`}>
              {service.name}
            </h3>
            <span className="font-bold text-xl text-chrona-accent">{service.preis.toFixed(2)} €</span>
          </div>

          <div className="flex gap-2 mt-2 flex-wrap">
            <div className="inline-flex items-center gap-1 bg-chrona-gray-700/50 px-2 py-1 rounded-md text-xs">
              <Clock size={12} className={selected ? "text-chrona-accent" : "text-chrona-gray-400"} />
              <span className="text-chrona-gray-300">{service.dauer} Min.</span>
            </div>
            <div className="inline-flex items-center gap-1 bg-chrona-gray-700/50 px-2 py-1 rounded-md text-xs">
              <Calendar size={12} className={selected ? "text-chrona-accent" : "text-chrona-gray-400"} />
              <span className="text-chrona-gray-300">{service.kategorie}</span>
            </div>
          </div>

          {service.beschreibung && (
            <p className="mt-3 text-sm text-chrona-gray-300 line-clamp-3">{service.beschreibung}</p>
          )}

          {service.addons_aktiv && service.addons_aktiv.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-1">
              {service.addons_aktiv.map((addon) => (
                <span
                  key={addon}
                  className={`px-2 py-1 text-xs rounded-full flex items-center gap-1 ${
                    selected
                      ? "bg-chrona-accent/20 text-chrona-accent"
                      : "bg-chrona-gray-700/50 text-chrona-gray-300"
                  }`}
                >
                  <Check size={10} /> {addon}
                </span>
              ))}
            </div>
          )}
        </div>

        {showBookButton && (
          <div className="mt-4 pt-4 border-t border-chrona-gray-700/50">
            <Button
              onClick={(e) => {
                e.stopPropagation();
                onBookClick && onBookClick();
              }}
              className="w-full bg-chrona-accent hover:bg-chrona-accent-light text-chrona-text shadow-md shadow-chrona-accent/20 transition-all duration-200"
            >
              Termin buchen
            </Button>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ServiceCard;
